import script from "./RegisterProperty.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterProperty.vue?vue&type=script&setup=true&lang=js"

import "./RegisterProperty.vue?vue&type=style&index=0&id=dcf83d56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcf83d56"]])

export default __exports__